const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- ]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
  PRICE: /^(([0-9]{0,9})|([.{1}]\d{0,2})|(\d+(\.\d{0,2})))?$/,
  ///^\d{0,2}+(\.\d{0,2})?$/
};

export const SUBCONTRACTOR_DETAILS = [
  {
    id: "name",
    label: "Full Name ",
    placeHolder: "Enter Name",
    type: "viewField",
    md: 12,
    isFlexField: true,
  },
  {
    id: "aka_name",
    label: "Short Name :",
    // tooltipText: "Short Name",
    placeHolder: "Enter Short Name",
    type: "viewField",
    md: 6,
    isFlexField: true,
  },
  {
    id: "phone",
    label: "Mobile :",
    placeHolder: "Enter Mobile",
    type: "viewField",
    md: 6,
    isFlexField: true,
  },
  {
    id: "email",
    label: "Email :",
    placeHolder: "Enter email",
    type: "viewField",
    md: 6,
    isFlexField: true,
  },
  {
    id: "contact_name",
    label: "Contact Name :",
    placeHolder: "Enter contact name",
    type: "viewField",
    md: 6,
    isFlexField: true,
  },

  {
    id: "address",
    label: "Address ",
    placeHolder: "Enter address",
    type: "viewField",
    md: 12,
    isFlexField: true,
  },
  {
    id: "notes",
    label: "Notes ",
    placeHolder: "Enter notes",
    type: "viewField",
    md: 12,
    isFlexField: true,
  },
];

export const SUBCONTRACTOR_FORM_FIELDS = [
  {
    id: "name",
    label: "Full Name :",
    placeHolder: "",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    // isRequired: true,
    patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 9,
  },
  {
    id: "contact_name",
    label: "Contact Name :",
    placeHolder: "",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    // isRequired: true,
    patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 3,
  },
  {
    id: "aka_name",
    label: "AKA Name :",
    placeHolder: "",
    type: "text",
    isRequired: true,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 4,
  },

  {
    id: "phone",
    label: "Phone :",
    placeholder: "",
    type: "contact",
    width: "80px",
    inputProps: {
      maxLength: 11,
    },
    patternAllowed: patternConstant?.NUMERIC,
    md: 4,
  },
  {
    id: "email",
    label: "Email :",
    placeholder: "",
    type: "text",
    width: "80px",
    // isRequired: true,
    // patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 4,
  },

  {
    id: "address",
    label: "Address :",
    placeholder: "",
    type: "textarea",
    // width: "80px",
    inputProps: {
      maxLength: 250,
    },
    // patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 12,
  },

  {
    id: "notes",
    label: "Notes :",
    placeHolder: "",
    type: "textarea",
    inputProps: {
      maxLength: 250,
    },
    // patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 12,
  },
];

export const SUBCONTRACTOR_QUOTE_HEADINGS : any[]=[
  {
    label:'Lead ID',
    align:'left',
  },
  {
    label:'Customer Name',
    align:'left',
  },
  {
    label:'Quote',
    align:'left',
  },
  {
    label:'Fee',
    align:'left',
  },
  {
    label:'Accepted',
    align:'left',
  },
  {
    label:'Completed',
    align:'left',
  },
  {
    label:'Sub Contractor Ref',
    align:'left',
  },
  {
    label:'Actions',
  }
]
